import Icon1 from "../../images/svg-2.svg";
import Icon2 from "../../images/svg-11.svg";
import Icon3 from "../../images/svg-8.svg";
import Icon4 from "../../images/svg-9.svg";
import Icon5 from "../../images/svg-7.svg";
import Icon6 from "../../images/svg-12.svg";

//For individuals
export const individualsHeroSection = {
  title: "Da vida a tu idea",
  description: "¿Tienes una idea que podría cambiarlo todo? Te ayudamos a convertirla en realidad con tecnología segura, escalable y diseñada especialmente para ti."
};

export const individualsOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  topLine: "Innovación Tecnológica",
  headLine: "De la inspiración a la ejecución",
  description:
    "Ya sea que hayas identificado una oportunidad única en el mercado, tengas una visión clara de un nuevo producto o simplemente quieras materializar ese proyecto que no deja de rondar tu mente, estamos aquí para ayudarte a construirlo.",
  buttonLabel: "Conócenos",
  imgStart: false,
  alt: "Tecnología",
  im: require("../../images/svg-15.svg").default,
  dark: true,
  primary: true,
  darkText: false,
  toR: "discover",
};

export const individualsTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  topLine: "Acceso Global",
  headLine: "Sin límites, desde donde estés",
  description:
    "No importa si estás en casa, viajando o trabajando desde tu cafetería favorita: nuestras soluciones funcionan desde cualquier dispositivo con conexión a internet, para que tu idea nunca se detenga.",
  buttonLabel: "Descubre Más",
  imgStart: true,
  alt: "Global",
  im: require("../../images/svg-5.svg").default,
  dark: false,
  primary: false,
  darkText: true,
  toR: "services",
};

export const individualsThree = {
  id: "signup",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Únete a la Innovación",
  headLine: "Tu primer paso hacia el software que imaginas",
  description:
    "Hablemos. Contáctanos y empieza hoy mismo a transformar esa gran idea en un producto que puede cambiarlo todo.",
  buttonLabel: "Empezar Ahora",
  imgStart: false,
  alt: "Progreso",
  im: require("../../images/svg-10.svg").default,
  dark: true,
  primary: true,
  darkText: false
};

export const individualsServices = {
  title: "Nuestros servicios",
  cards: [
    {
      icon: Icon1,
      title: "Inteligencia Artificial",
      description: "Integra modelos de AI desde el inicio para que tu producto aprenda, se adapte y escale contigo.",
    },
    {
      icon: Icon2,
      title: "Desarrollo Web",
      description: "Creamos experiencias digitales modernas, ágiles y centradas en los usuarios de tu futuro producto.",
    },
    {
      icon: Icon3,
      title: "Soluciones a Medida",
      description: "Cada idea es única. Diseñamos software ajustado a la esencia de tu visión.",
    },
    {
      icon: Icon4,
      title: "Despliegue de Infraestructura",
      description: "Lanzamos tu proyecto sobre bases sólidas: sistemas eficientes, preparados para escalar y crecer contigo.",
    },
    {
      icon: Icon5,
      title: "Análisis de Datos",
      description: "Desde el primer click decisiones informadas y estrategias impulsadas por datos.",
    },
    {
      icon: Icon6,
      title: "Seguridad y Escalabilidad",
      description: "Construimos con visión de futuro. Tu producto será seguro desde el día uno y listo para crecer con el éxito.",
    },
  ],
};


//------------------------------------------------------------------

//For business
export const businessHeroSection = {
  title: "Innovación para tu Negocio",
  description: "Empieza hoy con nosotros y transforma tu negocio con herramientas seguras, escalables y a la medida de tus necesidades."
};

export const businessOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  topLine: "Innovación Tecnológica",
  headLine: "Soluciones seguras y escalables para tus necesidades",
  description:
    "Ofrecemos servicios de vanguardia en inteligencia artificial, desarrollo web, despliegues robustos y análisis de datos, diseñados para llevar tu negocio al siguiente nivel.",
  buttonLabel: "Conócenos",
  imgStart: false,
  alt: "Tecnología",
  im: require("../../images/svg-12.svg").default,
  dark: true,
  primary: true,
  darkText: false,
  toR: "discover",
};

export const businessTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  topLine: "Acceso Global",
  headLine: "Soluciones personalizadas desde cualquier lugar",
  description:
    "Nuestro equipo crea aplicaciones y herramientas accesibles desde cualquier dispositivo con conexión a internet, para mantener tu negocio siempre en marcha.",
  buttonLabel: "Descubre Más",
  imgStart: true,
  alt: "Global",
  im: require("../../images/svg-5.svg").default,
  dark: false,
  primary: false,
  darkText: true,
  toR: "services",
};

export const businessThree = {
  id: "signup",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Únete a la Innovación",
  headLine: "Empieza tu proyecto con nosotros en minutos",
  description:
    "Contáctanos rápidamente y da el primer paso hacia soluciones tecnológicas innovadoras que transformarán tu negocio.",
  buttonLabel: "Empezar Ahora",
  imgStart: false,
  alt: "Progreso",
  im: require("../../images/svg-10.svg").default,
  dark: true,
  primary: true,
  darkText: false
};

export const businessServices = {
  title: "Nuestros servicios",
  cards: [
    {
      icon: Icon1,
      title: "Inteligencia Artificial",
      description: "Modelos de AI para optimizar procesos y decisiones estratégicas.",
    },
    {
      icon: Icon2,
      title: "Desarrollo Web",
      description: "Creamos sitios web rápidos y modernos, adaptados a tu negocio.",
    },
    {
      icon: Icon3,
      title: "Soluciones a Medida",
      description: "Herramientas diseñadas para tus necesidades específicas.",
    },
    {
      icon: Icon4,
      title: "Despliegue de Infraestructura",
      description: "Implementamos sistemas escalables y eficientes para tu negocio.",
    },
    {
      icon: Icon5,
      title: "Análisis de Datos",
      description: "Análisis avanzado para tomar decisiones basadas en datos.",
    },
    {
      icon: Icon6,
      title: "Seguridad y Escalabilidad",
      description: "Soluciones confiables, seguras y preparadas para crecer contigo.",
    },
  ],
};